export function isMobile() {

	var mobile = false;
	var width = window.innerWidth;
	if (width < 768) { mobile = true; }
	return mobile;
};

